import { render, staticRenderFns } from "./ServiciosMasSolicitados.vue?vue&type=template&id=006ba102&scoped=true"
import script from "./ServiciosMasSolicitados.vue?vue&type=script&lang=js"
export * from "./ServiciosMasSolicitados.vue?vue&type=script&lang=js"
import style0 from "./ServiciosMasSolicitados.vue?vue&type=style&index=0&id=006ba102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ba102",
  null
  
)

export default component.exports